/**
 * Created by tomers on 2/27/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/integrations/integrationsRowAttributeItemView.tmpl");

    var IntegrationsRowAttributeItemView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsRowAttributeItemView = Marionette.ItemView.extend({
            template:template,
            tagName: "li",
            className: "integration-row-attribute-container",
            ui: {
                "itemContainer": ".integration-row-attribute"
            },

            customTemplateHelpers: function() {
                return {
                    connected: this.model.isConnected(),
                    name: this.model.getName()
                };
            },

            initialize: function(options){
                LEManager.logger.debug("AttributeItemView:initialize");
                this.listenTo(this.model, "change:connections", this._onConnectedStateChange);
            },

            _onConnectedStateChange: function(){
                LEManager.logger.debug("AttributeItemView:_onConnectedStateChange");
                this.ui.itemContainer.removeClass("connected");
                this._setTooltipWhenConnected();
            },

            _setTooltipWhenConnected: function(){
                LEManager.logger.debug("AttributeItemView:_setTooltipWhenConnected");
                if(this.model.isConnected()) {
                    LEManager.logger.debug("AttributeItemView:_setTooltipWhenConnected - this.model.isConnected() is true");
                    this.ui.itemContainer.addClass("connected");
                    this.ui.itemContainer.attr("title", this.model.getConnectionTooltip());
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsRowAttributeItemView;
});
